module.exports = {
  // 应用标题，由各环境 .env 的 VUE_APP_TITLE 注入，缺省保持胖不等达人CRM
  title: process.env.VUE_APP_TITLE || "胖不等达人CRM",
  secret: "va",
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,
  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,
  timezone: 0
};